import { Button, Icon } from '@chakra-ui/react';
import { Share2Icon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { ModalTrigger } from '~/common/components/Modal/ModalTrigger';
import { useCreateBuyerOfferAnalysis } from '../../../BuyerOfferAnalysis/hooks/useCreateBuyerOfferAnalysis';
import { CreateOfferScorecardButton } from '../CreateOfferScorecardButton';
import { useListingPageContext } from '../ListingPageContext';
import { ShareListingReportWithClientModal } from '../ShareListingReportWithClientModal';

export const ShareWithClientButton = () => {
  const { isViewOnly } = useListingPageContext();

  if (isViewOnly) {
    return null;
  }

  return (
    <ModalTrigger modal={ShareListingReportWithClientModal}>
      <Button
        leftIcon={<Icon as={Share2Icon} boxSize={4} />}
        size="sm"
        variant={{
          base: 'outline',
          md: 'solid',
        }}
      >
        Share with Client
      </Button>
    </ModalTrigger>
  );
};

export const OfferScorecardButton = () => {
  const { listing, isOffMarketListing, isViewOnly } = useListingPageContext();
  const navigate = useNavigate();

  const { handleCreate, loading: isCreatingScorecard } =
    useCreateBuyerOfferAnalysis();

  if (isViewOnly || isOffMarketListing) {
    return null;
  }

  const onCreateOfferScorecard = async () => {
    if (!listing?.id) {
      return;
    }

    const boa = await handleCreate({ listingId: listing.id });
    if (!boa?.id) {
      return;
    }
    navigate(`/offer-scorecard/${boa.id}`);
  };

  return (
    <CreateOfferScorecardButton
      loading={isCreatingScorecard}
      onClick={() => void onCreateOfferScorecard()}
    />
  );
};
